export default "__VITE_ASSET__KtgGKxk5__"